<template>
	<v-dialog
		v-model="showDialog"
		max-width="960px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">製品完成通知</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<v-row no-gutters justify="end">
					<ConfirmationDialog
						:dialog.sync="messageConfirmationDialog"
						:confirm_options="message_confirm_options"
						requireBtn
						@accept="notifySales('message')"
					>
						<template v-slot:open-btn-content
							><v-icon class="mr-1"> mdi-message-outline </v-icon> 営業へ通知
						</template>
					</ConfirmationDialog>
					<ConfirmationDialog
						:dialog.sync="mailConfirmationDialog"
						:confirm_options="mail_confirm_options"
						requireBtn
						@accept="notifySales('mail')"
					>
						<template v-slot:open-btn-content
							><v-icon class="mr-1"> mdi-email-outline </v-icon> 営業へメール
						</template>
					</ConfirmationDialog>
				</v-row>
				<table width="100%" class="mt-4 show-dialog-table">
					<tbody>
						<ShowDetailRecord :columnName="'製造番号'">
							<template v-slot:value>
								<a @click="openOrderIndividualInfoDialog(order_individual_info)">
									{{ common.productNumberByOrderIndividualInfo(order_individual_info) }}
								</a>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord
							:columnName="'製品名'"
							:value="common.productNameWithSubName(order_individual_info.ordered_product)"
						/>
						<ShowDetailRecord :columnName="'数量'" :value="order_individual_info.quantity" />
					</tbody>
				</table>
				<table width="100%" class="mt-2 show-dialog-table">
					<tbody>
						<tr>
							<th class="font-weight-bold" width="100%">関連資料一覧</th>
						</tr>
						<template v-if="attached_files.length">
							<tr v-for="file in attached_files" :key="file.id">
								<td width="100%">
									<a class="d-flex" :href="file.url" target="_blank">
										{{ file.name }}
									</a>
								</td>
							</tr> </template
						><template v-else>
							<tr>
								<td width="100%">
									<p>関連資料がありません。</p>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</v-sheet>
		</v-card>
		<OrderIndividualInfoShowDialog :id="selectedInfoId" :dialog.sync="infoDialog" />
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import OrderIndividualInfoShowDialog from "../../order_individual_info/components/OrderIndividualInfoShowDialog.vue"
import ConfirmationDialog from "../../shared/ConfirmationDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: null,
			required: false,
		},
		authority_flag: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
		OrderIndividualInfoShowDialog,
		ConfirmationDialog,
	},
	data() {
		return {
			order_individual_info: {
				ordered_product: {
					product: {},
				},
			},
			attached_files: [],
			selectedInfoId: null,
			infoDialog: false,
			approvalDialog: false,
			valid: false,
			menu: false,
			reason: null,
			common,
			rules,
			messageConfirmationDialog: false,
			mailConfirmationDialog: false,
			message_confirm_options: {
				title: "送信前確認",
				description:
					"システム内のメッセージで営業担当者へ製品完成通知を送信します。\n本当に送信しますか？",
				accept_text: "送信",
				cancel_text: "キャンセル",
			},
			mail_confirm_options: {
				title: "送信前確認",
				description: "メールで営業担当者へ製品完成通知を送信します。\n本当に送信しますか？",
				accept_text: "送信",
				cancel_text: "キャンセル",
			},
		}
	},
	methods: {
		fetchOrderIndividualInfo() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/notify_sales/${this.id}`
			axios
				.get(url, { headers })
				.then((res) => {
					this.order_individual_info = res.data.order_individual_info
					if (this.order_individual_info.notify_sales_flag) {
						this.setDescription()
					}
					this.attached_files = res.data.attached_files
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		notifySales(notify_method) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/notify_sales/${this.id}`
			axios
				.put(url, { notify_method }, { headers })
				.then((res) => {
					// TODO
					if (res.data.notify_sales_flag) {
						this.setDescription()
					}
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "送信しました。",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openOrderIndividualInfoDialog(id) {
			this.selectedInfoId = id
			this.infoDialog = true
		},
		setDescription() {
			this.message_confirm_options.description =
				"製品完成通知は既に送信されています。\nもう一度送信しますか？"
			this.mail_confirm_options.description =
				"製品完成通知は既に送信されています。\nもう一度送信しますか？"
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchOrderIndividualInfo(newVal)
		},
		deep: true,
	},
}
</script>
<style lang="scss" scoped>
table {
	th {
		font-weight: bold;
		width: 200px;
		min-width: 200px;
		padding: 4px 8px;
		// background-color: lightgrey;
		background-color: whitesmoke;
		border-bottom: 1px solid white;
		border-right: 1px solid white;
	}
	th.result-th {
		background-color: whitesmoke;
	}
	td {
		width: 200px;
		min-width: 200px;
		padding: 4px;
		border: 1px solid whitesmoke;
		white-space: normal;
		p {
			white-space: pre-wrap;
		}
		p.no-wrap {
			white-space: nowrap;
		}
	}
}
</style>
